<div class="border border-outline dark:border-outline-darkmode rounded-lg overflow-hidden">
  <ng-content />
</div>
